import React from 'react';

const BannerItem = ({
  title,
  subTitle,
  url,
  imageUrl,
  imageAlt,
}: FooterBannerIconItem) => {
  return (
    <div className="flex flex-row gap-x-3">
      <img src={imageUrl} alt={imageAlt} className='w-10 h-10'/>
      <div className="flex flex-col justify-center">
        <div className="text-white text-md">{title}</div>
        {!url && (
          <div
            className="text-white font-satoshi-bold text-lg underline leading-[24px]"
            dangerouslySetInnerHTML={{ __html: subTitle }}
          ></div>
        )}
        {url && (
          <a
            href={url}
            className="text-white font-satoshi-bold text-lg underline leading-[24px]"
          >
            {subTitle}
          </a>
        )}
      </div>
    </div>
  );
};

export const Banner = ({
  title,
  subTitle,
  items,
  imageUrl,
}: FooterBanner) => {
  const bannerItems = items.map((item, idx) => {
    return <BannerItem key={idx} {...item} />;
  });

  return (
    <div
      className="bg-gray-900 border-b-[5px] border-solid border-primary-500 pt-6 pb-8 px-5 rounded bg-right-bottom bg-no-repeat lg:p-8 xl:py-10 xl:px-12 mb-6 xl:mb-0"
      style={{ backgroundImage: `url(${imageUrl})` }}
    >
      <h4 className="text-white font-satoshi-bold">{title}</h4>
      <div className="text-white text-lg leading-[24px] mt-2">
        {subTitle}
      </div>
      <div className="pt-6 grid gap-6 grid-cols-1 md:grid-cols-2">
        {bannerItems}
      </div>
    </div>
  );
};
